import axios from 'axios';
export default axios.create({
    baseURL:"https://fakeapi.click",
    headers:{
        "Content-type":"application/json"
    }
})